import { authAPI } from '@/api/client'

import { LoginHeader } from '@/components/login/LoginHeader'
import { LoginHero } from '@/components/login/LoginHero'
import { LoginAuthButtons } from '@/components/login/LoginAuthButtons'
import { LoginTerms } from '@/components/login/LoginTerms'
import { Card } from '@/components/ui/card'

export function LoginPage() {
  const handleGoogleSignIn = () => {
    authAPI.googleLogin()
  }

  const handleAppleSignIn = () => {
    authAPI.appleLogin()
  }

  return (
    <div className="flex min-h-full flex-col bg-gray-100">
      {/* Main content - Full width on both mobile and desktop */}
      <div className="flex flex-1 items-center justify-center p-4 lg:p-8">
        <div className="w-full max-w-sm space-y-6 lg:max-w-md lg:space-y-8">
          <LoginHeader />
          <LoginHero />

          {/* OAuth Sign-in Buttons - Mobile-first responsive */}
          <Card className="rounded-2xl p-6 shadow-mobile lg:p-8 lg:shadow-card">
            <LoginAuthButtons
              onGoogleSignIn={handleGoogleSignIn}
              onAppleSignIn={handleAppleSignIn}
            />
            <LoginTerms />

            {/* TODO: REMOVE BEFORE PRODUCTION - Dev login UI */}
            {}
          </Card>
        </div>
      </div>
    </div>
  )
}
